export const DEFAULT_PORTAL_TARGET = "portal-root";
